import React, { useCallback, useState } from "react";
import { Button, Col, Form, Nav, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import logger from "../../../../../utils/logger";
import { setToast } from "../../../../controller/reducer/ui";
import LocSelector from "../../common/loc-selector";
import TagSelector from "../../common/tag-selector";

const twitterTrailer =
  "-%22not+verified%22+-%22unverified%22+-%22needed%22+-%22need%22+-%22needs%22+-%22required%22+-%22require%22+-%22requires%22+-%22requirement%22+-%22requirements%22&f=live";

const olinks = [
  {
    link: "https://covidkhoj.in/seeker",
    tag: "covidkhoj",
  },
  {
    link: "https://covidhelpers.co.in/",
    tag: "covidhelpers",
  },
  {
    link: "https://fastaid.in/home/6085272862ce493a176fe1f0/1",
    tag: "fastaid",
  },
];
const tagIdMap = {
  oxygen: [{ Oxygen: 4 }],
  beds: [{ Beds: 3 }, { "ICU Beds": 10 }],
  plasma: [{ Plasma: 5 }],
  ambulance: [{ Ambulance: 1 }],
  vaccination: [],
  verified: [],
  "all information": [
    { "Home Nurse": 14 },
    { Doctor: 15 },
    { "Diet Advice": 2 },
  ],
  "food services": [{ "Food for Patients": 11 }],
  medicines: [{ Oxygemeter: 8 }, { Thermometer: 9 }],
  testing: [{ Testing: 12 }],
  "black fungus": [],
};

// const tagToTagMap = {
//   oxygen: ["Oxygen","Concentrator","Ventilator"],
//   beds: ["Non-ICU Bed","ICU Bed"],
//   plasma: ["Plasma","Blood"],
//   ambulance: ["Ambulance"],
//   vaccination: ["Vaccine","Testing"],
//   verified: ["Helpline"],
//   "all information": ["Hospital","Counselling","Cremation","Doctor","Home Nurse"],
//   "food services": ["Food"],
//   ngo: ["Helpline"],
//   medicines: ["Medicine","Injection","Remdesivir","Telemedicine"],
// };

const tagToTagMap = {
  oxygen: ["Oxygen", "Ventilator"],
  beds: ["Non-ICU Bed", "ICU Bed"],
  plasma: ["Plasma"],
  ambulance: ["Ambulance"],
  vaccination: ["Vaccine"],
  testing: ["Testing"],
  verified: ["Helpline"],
  "all information": ["Hospital", "Doctor"],
  "food services": ["Food"],
  medicines: ["Medicine", "Remdesivir"],
  "black fungus": [],
};
/*
https://covidkhoj.in/seeker
https://covidhelpers.co.in/
https://fastaid.in/home/6085272862ce493a176fe1f0/1
*/

const UnififedSearch = () => {
  const [loc, setLoc] = useState(null);
  const [city, setCity] = useState("");
  const [tags, setTags] = useState([]);
  const [llink, setLlink] = useState("");
  const [tlink, setTlink] = useState("");
  const [blink, setBlink] = useState("");
  const [cflinks, setCFlinks] = useState([]);
  const [cclinks, setCClinks] = useState([]);
  const dispatch = useDispatch();

  const locLink = useCallback(
    (loc, city, tags) => {
      let link = `/location/${loc.value
        .split(" ")
        .join("_")}?search=${city}&tags=[${tags.map((t) => t.value)}]`;
      return link;
    },
    [loc, city, tags]
  );

  const bedLink = useCallback(
    (loc, tags) => {
      if (tags.map((t) => t.value).includes("beds"))
        return `/track?search=${loc.value.split(" ").join("_")}`;
      return "";
    },
    [loc, city, tags]
  );

  const twitterLink = useCallback(
    (city, tags) => {
      const newTags = [...tags.map((t) => t.value)];
      if (newTags.includes("beds")) newTags.push("bed");
      let tagStr =
        "+(" +
        newTags.filter((it) => it != "all information").join("+OR+") +
        ")+";
      let link = `https://twitter.com/search?q=verified+${city}`;
      link += tagStr;
      link += twitterTrailer;
      return link;
    },
    [city, tags]
  );

  const covidCitizensLinks = useCallback(
    (city, tags) => {
      let links = [];
      tags
        .map((t) => tagToTagMap[t.value])
        .forEach((tagList) => {
          tagList.forEach((tag) => {
            const link = `https://covidcitizens.org/${city}/${tag}`;
            links.push({ tag, link });
          });
        });
      links.push({
        link: `https://covidcitizens.org/`,
        tag: "All Info",
      });
      return links;
    },
    [city, tags]
  );

  const covidFightClubLinks = useCallback(
    (city, tags) => {
      let links = [];
      tags
        .map((t) => t.value)
        .forEach((tag) => {
          tagIdMap[tag].forEach((obj) => {
            const link = `https://covidfightclub.org/?search_key=${city}&city_id=&medicine_id=${
              Object.values(obj)[0]
            }&type=`;
            links.push({ tag: Object.keys(obj)[0], link });
          });
        });
      links.push({
        link: `https://covidfightclub.org/?search_key=${city}&city_id=&medicine_id=&type=`,
        tag: "All Info",
      });
      return links;
    },
    [city, tags]
  );

  const reset = () => {
    setLoc(null);
    setCity("");
    setTags([]);
    setTlink("");
    setBlink("");
    setLlink("");
    setCFlinks([]);
    setCClinks([]);
  };

  const submit = (e) => {
    e.preventDefault();
    logger()(loc);
    if (loc === null) {
      dispatch(setToast("State/UTs cannot be empty"));
      return;
    }
    setLlink(locLink(loc, city, tags));
    setBlink(bedLink(loc, tags));
    setTlink(twitterLink(city === "" ? loc.value.toLowerCase() : city, tags));
    setCFlinks(
      covidFightClubLinks(city === "" ? loc.value.toLowerCase() : city, tags)
    );
    setCClinks(
      covidCitizensLinks(city === "" ? loc.value.toLowerCase() : city, tags)
    );
  };

  return (
    <div>
      <div className="d-flex justify-content-between">
        <p className="h3 font-weight-normal ml-4">Master Search </p>
        <Button
          variant="outline-danger"
          size="sm"
          className="mr-4"
          onClick={reset}
        >
          {" "}
          Clear{" "}
        </Button>
      </div>
      <Form className="ml-4 mr-4 mt-4" onSubmit={submit}>
        <LocSelector loc={loc} setLoc={setLoc} />
        <br />
        <Form.Group controlId="city">
          <Form.Control
            maxLength="20"
            type="text"
            placeholder="Enter City if Applicable"
            value={city}
            onChange={(e) => setCity(e.currentTarget.value.toLowerCase())}
          />
        </Form.Group>
        <TagSelector isRemedy={false} tags={tags} setTags={setTags} />
        <br />
        <Button variant="primary" type="submit" block>
          Search
        </Button>
      </Form>

      <Nav className="flex-column m-4">
        {blink !== "" && (
          <Nav className="border ml-1 mr-1 border-danger bg-danger">
            <Nav.Link href={blink} target="_blank" className="text-white">
              Live Bed Track Search
            </Nav.Link>
          </Nav>
        )}
        {llink !== "" && (
          <Nav className="border ml-1 mr-1 border-secondary bg-secondary">
            <Nav.Link href={llink} target="_blank" className="text-white">
              Location Resources Search
            </Nav.Link>
          </Nav>
        )}
        {tlink !== "" && (
          <Nav className="border ml-1 mr-1 border-primary bg-primary">
            <Nav.Link href={tlink} target="_blank" className="text-white">
              Twitter Search
            </Nav.Link>
          </Nav>
        )}
        {cflinks.length > 0 && (
          <div className="ml-1 mr-1  border border-success">
            <p className="h6  bg-success pl-2 p-1 text-light">
              Covid Fight Club Search
            </p>
            <Nav>
              {cflinks.map((item, id) => (
                <Nav.Link key={id} href={item.link} target="_blank">
                  {item.tag}
                </Nav.Link>
              ))}
            </Nav>
          </div>
        )}
        {cclinks.length > 0 && (
          <div className="ml-1 mr-1  border border-info">
            <p className="h6 pl-2 p-1 bg-info text-light">
              Covid Citizens Search
            </p>
            <Nav>
              {cclinks.map((item, id) => (
                <Nav.Link key={id} href={item.link} target="_blank">
                  {item.tag}
                </Nav.Link>
              ))}
            </Nav>
          </div>
        )}
        {llink !== "" && (
          <div className="ml-1 mr-1  border border-dark">
            <p className="h6 pl-2 p-1 bg-dark text-light">Other Useful Links</p>
            <Nav>
              {olinks.map((item, id) => (
                <Nav.Link key={id} href={item.link} target="_blank">
                  {item.tag}
                </Nav.Link>
              ))}
            </Nav>
          </div>
        )}
      </Nav>
    </div>
  );
};

export default UnififedSearch;
